import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type RemoteProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function RemoteIcon({
  className,
  pathClassName = "stroke-gray-800",
  ...props
}: RemoteProps) {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...props}
    >
        <Path
        d="M12.165 2.22H3.832a2 2 0 00-2 2v5.247a2 2 0 002 2h8.333a2 2 0 002-2V4.221a2 2 0 00-2-2zM8 11.467v2.313M5.688 13.78h4.626"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default RemoteIcon;
